import http from "./http_common";

class CartOrderService {
  queryString(payload) {
    return Object.keys(payload)
      .map((key) => key + "=" + payload[key])
      .join("&");
  }
  AddToCart(data) {
    return http.post(`CartDetails/`, data);
  }
  getOrderList(data) {
    var queryString = this.queryString(data);
    return http.get(`/CartDetails/list/filter?${queryString}`);
  }
  UpdateCartAddress(data) {
    return http.put(`CartOrderHrd/updateAddress/`, data);
  }
  transferCartItems(payload) {
    const queryString = this.queryString(payload);
    return http.put(`/CartDetails/?${queryString}`);
  }
}

export default new CartOrderService();
